import React from 'react';

const SdkPicker1 = ({ visibility }) =>
  <div className={`step-hidden-visibility ${visibility ? 'step-visibility' : ''}`}>
    <svg
      width="555"
      height="533"
      viewBox="0 0 555 533"
      className="sdk-picker-1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMinYMin meet"
    >
      <defs>
        <rect id="path-1" x="5" y="102" width="162" height="54" rx="3.6" />
        <filter
          x="-54.3%"
          y="-142.6%"
          width="208.6%"
          height="425.9%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <femorphology radius="2.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1">
            <feoffset dy="11" in="shadowSpreadOuter1" result="shadowOffsetOuter1">
              <fegaussianblur stdDeviation="25" in="shadowOffsetOuter1" result="shadowBlurOuter1">
                <fecolormatrix
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
                  in="shadowBlurOuter1"
                />
              </fegaussianblur>
            </feoffset>
          </femorphology>
        </filter>
        <ellipse id="path-3" cx="22.5" cy="22.443" rx="21.625" ry="21.526" />
      </defs>
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="Group" transform="translate(0 -47)">
          <g id="body" transform="translate(0 47)">
            <rect id="Rectangle" fill="#F7F7F7" width="555" height="533" rx="3" />
            <path
              d="M56.4356434,54.2693135 L53.4053728,44.9995532 L61.3374882,39.2720838 L51.5325397,39.2720838 L48.5019094,30.002681 L48.5010102,30.0001787 L58.3075773,30.0001787 L61.3387471,39.2711902 L61.3387471,39.2710114 L61.3412648,39.2695816 C63.101879,44.6479872 61.2887521,50.7652712 56.4356434,54.2693135 L56.4356434,54.2693135 L56.4356434,54.2693135 Z M40.5678157,54.2693135 L40.565298,54.2711008 L48.4995715,60 L56.4356434,54.2694922 L48.5020892,48.5404143 L40.5678157,54.2693135 L40.5678157,54.2693135 L40.5678157,54.2693135 Z M35.6638128,39.2697603 L35.6638128,39.2697603 C33.8107619,44.9393205 35.9618044,50.946863 40.5661972,54.2703859 L40.5669166,54.2675262 L43.5975468,44.998302 L35.6670499,39.2719051 L45.4696606,39.2719051 L48.5004707,30.0025022 L48.50119,30 L38.6940834,30 L35.6638128,39.2697603 L35.6638128,39.2697603 L35.6638128,39.2697603 Z"
              id="Shape"
              fill="#EB5424"
            />
            <path
              d="M35,92 L95,92"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,114 L75,114"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,136 L85,136"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,158 L105,158"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,180 L75,180"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <path
              d="M35,202 L55,202"
              id="Line"
              stroke="#000"
              strokeWidth="4"
              opacity=".11"
              strokeLinecap="square"
            />
            <text
              id="Application-Type"
              fontFamily="FaktPro-Medium, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
              fontSize="24"
              fontWeight="400"
              fill="#333"
            >
              <tspan x="145" y="101">Application Type</tspan>
            </text>
            <rect
              id="Rectangle-3"
              stroke="#000"
              strokeWidth="2"
              opacity=".11"
              x="146"
              y="138"
              width="142"
              height="95"
              rx="2.7"
            />
            <circle
              id="Oval-3"
              strokeOpacity=".11"
              stroke="#000"
              strokeWidth="2"
              cx="216"
              cy="175"
              r="18"
            />
            <text
              id="Mobile-/-Native-App"
              opacity=".11"
              fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
              fontSize="11"
              fontWeight="500"
              fill="#000"
            >
              <tspan x="165.46" y="214">Mobile / Native App</tspan>
            </text>
            <rect
              id="Rectangle-3"
              stroke="#000"
              strokeWidth="2"
              opacity=".11"
              x="146"
              y="261"
              width="142"
              height="95"
              rx="2.7"
            />
            <circle
              id="Oval-3"
              strokeOpacity=".11"
              stroke="#000"
              strokeWidth="2"
              cx="217"
              cy="298"
              r="18"
            />
            <text
              id="Web-App"
              opacity=".11"
              fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
              fontSize="11"
              fontWeight="500"
              fill="#000"
            >
              <tspan x="193.888" y="337">Web App</tspan>
            </text>
            <rect
              id="Rectangle-3"
              stroke="#000"
              strokeWidth="2"
              opacity=".11"
              x="316"
              y="261"
              width="142"
              height="95"
              rx="2.7"
            />
            <circle
              id="Oval-3"
              strokeOpacity=".11"
              stroke="#000"
              strokeWidth="2"
              cx="387"
              cy="298"
              r="18"
            />
            <text
              id="Backend-/-API"
              opacity=".11"
              fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
              fontSize="11"
              fontWeight="500"
              fill="#000"
            >
              <tspan x="350.359" y="337">Backend / API</tspan>
            </text>
            <g id="Group-6" transform="translate(301 127)">
              <use
                filter="url(#filter-2)"
                xlinkHref="#path-1"
                id="Rectangle-17"
                opacity=".464"
                fill="#000"
              />
              <rect id="Rectangle-3" fill="#FFF" width="173" height="156" rx="3.24" />
              <g id="Group-7" transform="translate(64 23)">
                <mask id="mask-4" fill="#fff">
                  <use xlinkHref="#path-3" />
                </mask>
                <use id="Oval-3" fill="#EDEDED" xlinkHref="#path-3" />
                <g id="spa" mask="url(#mask-4)" fillRule="nonzero">
                  <g transform="translate(11 11)">
                    <polygon
                      id="Fill-34"
                      fill="#44C7F4"
                      points="9.20426236 12 16.1074729 0 6.9032106 0 0 12 6.9032106 24 16.1074729 24"
                    />
                    <polygon
                      id="Fill-36"
                      fill="#EC5424"
                      points="13.7949073 12 6.89169674 24 16.0959591 24 22.9991697 12 16.0959591 0 6.89169674 0"
                    />
                    <polygon
                      id="Fill-38"
                      fill="#16214D"
                      points="16.0959591 0 6.89169674 0 11.4938279 8.00000002"
                    />
                    <polygon
                      id="Fill-40"
                      fill="#16214D"
                      points="6.89169674 24 16.0959591 24 11.4938279 16"
                    />
                  </g>
                </g>
              </g>
              <text
                id="Single-Page-App"
                opacity=".7"
                fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                fontSize="11"
                fontWeight="500"
                fill="#060A1C"
              >
                <tspan x="36" y="91">Single Page App</tspan>
              </text>
              <g id="Default" transform="translate(50 102)">
                <g className="animate-button">
                  <rect id="Rectangle-16" fill="#EB5424" width="73" height="34" rx="2" />
                  <text
                    id="SELECT"
                    fontFamily="FaktPro-SemiBold, Fakt Pro, Helvetica Neue, Hevetica, sans-serif"
                    fontSize="12"
                    fontWeight="500"
                    letterSpacing=".427"
                    fill="#FFF"
                  >
                    <tspan x="15" y="20.5">SELECT</tspan>
                  </text>
                </g>
              </g>
            </g>
            <rect
              id="Rectangle-2"
              fill="#F7F7F7"
              transform="matrix(1 0 0 -1 0 8)"
              width="555"
              height="8"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>;

export default SdkPicker1;



// WEBPACK FOOTER //
// ./src/pages/jp/homepage/components/OnboardingFlow/svg/SdkPicker1.js